import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";

@Injectable({
    providedIn: 'root',
})
export class NotificationService {

    private apiUrl = environment.apiUrl + 'Notification';

    constructor(private http: HttpClient) {

    }

    public getNotifications() {
        return this.http.get<any>(`${this.apiUrl}`);
    }

    public setNotificationDone(id: string) {
        const url = `${this.apiUrl}/done/${id}`;
        return this.http.put<any>(url, {});
    }
    
}